// extracted by mini-css-extract-plugin
export default {"chooseSizeContainer":"index_chooseSizeContainer__-tSjd"};